// extracted by mini-css-extract-plugin
export default {"completedMain":"completedStyle_completedMain__JtU4c","custom_message":"completedStyle_custom_message__hkX+D"};